import {
  overdueSectionID,
  ReorderResult,
  Task,
  TaskListTreeItem,
  TaskType,
  Timestamp,
  WeekDays,
} from '@griply/types';
import {
  filterReorderableChildIds,
  getTaskIdFromTreeId,
  getTaskRescheduleUpdate,
  getUpcomingSectionDate,
  UpcomingSectionPrefixes,
} from '@griply/utils';

export type OnUpcomingDeadlineForeignDropOptions = {
  tasks: Task[];
  // the target section with the dropped ids already in its children
  section: TaskListTreeItem;
  today: Timestamp;
  weekStartsOn: WeekDays;
  prefixes: UpcomingSectionPrefixes;
};

export const onUpcomingDeadlineForeignDrop = ({
  tasks,
  section,
  today,
  weekStartsOn,
  prefixes,
}: OnUpcomingDeadlineForeignDropOptions): ReorderResult | null => {
  if (section.id === overdueSectionID || !tasks.length) {
    return null;
  }

  const date = getUpcomingSectionDate(section.id, prefixes);
  if (!date) {
    return null;
  }

  // A todo keeps its time of day, like an in-list reorder; a habit gets an all-day occurrence.
  const updatedTasks = tasks.map((task) =>
    getTaskRescheduleUpdate(
      task,
      date,
      task.type === TaskType.Task ? task.timeslot ?? null : null,
      { today, weekStartsOn },
    ),
  );

  return {
    updatedSections: [
      {
        id: section.id,
        taskSorting: filterReorderableChildIds(
          section.children?.map(getTaskIdFromTreeId),
        ),
      },
    ],
    updatedTasks,
  };
};
